import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/contractInvoicePartner'

function* fetchContractInvoicePartnersRefresh() {
  try {
    let fe = JSON.parse(localStorage.getItem('fetchContractInvoicePartners'))
    if (fe == null) {
      fe = { size: 10, index: 0, searchTerm: '%20', orderBy: '%20' }
    }
    const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
    yield put({
      type: actions.LIST_CONTRACTINVOICEPARTNER,
      result,
    })
  } catch (e) {
    console.error('fetchContractInvoicePartnersRefresh error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractInvoicePartners({ size, index, searchTerm, orderBy }) {
  try {
    // Load last params from last session.
    if (!size && !index && !searchTerm && !orderBy) {
      const fe = JSON.parse(localStorage.getItem('fetchContractInvoicePartners'))
      if (fe != null) {
        size = fe.size || 10
        index = fe.index || 0
        searchTerm = fe.searchTerm || '%20'
        orderBy = fe.orderBy || '%20'
      } else {
        size = 10
        index = 0
        searchTerm = '%20'
        orderBy = '%20'
      }
    }
    localStorage.setItem(
      'fetchContractInvoicePartners',
      JSON.stringify({ size, index, searchTerm, orderBy }),
    )
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(list, size, index, searchTerm, orderBy)
    yield put({
      type: actions.LIST_CONTRACTINVOICEPARTNER,
      result,
    })
  } catch (e) {
    console.error('fetchContractInvoicePartners error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractInvoicePartnerEdit({ id }) {
  try {
    yield put({
      type: actions.REQUESTING,
    })
    const result = yield call(find, id)
    yield put({
      type: actions.EDIT_CONTRACTINVOICEPARTNER,
      result,
    })
  } catch (e) {
    console.error('fetchContractInvoicePartnerEdit error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractInvoicePartnerSave(values) {
  try {
    const result = yield call(save, values)
    if (result !== null) {
      notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
    }
    yield put({
      type: actions.SAVE_CONTRACTINVOICEPARTNER_RECIEVED,
      result,
    })
    yield put({
      type: actions.RE_FETCH_CONTRACTINVOICEPARTNERS,
    })
  } catch (e) {
    console.error('fetchContractInvoicePartnerSave error', e)
    notification.error({ message: 'Save failed', description: e.message })
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractInvoicePartnerDelete(values) {
  try {
    const result = yield call(remove, values)
    if (result !== null) {
      notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
    }
    yield put({
      type: actions.DELETE_CONTRACTINVOICEPARTNER_RECIEVED,
      result,
    })
    yield put({
      type: actions.RE_FETCH_CONTRACTINVOICEPARTNERS,
    })
  } catch (e) {
    console.error('fetchContractInvoicePartnerDelete error', e)
    notification.error({ message: 'Delete failed', description: e.message })
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_CONTRACTINVOICEPARTNERS, fetchContractInvoicePartners),
    takeEvery(actions.FETCH_CONTRACTINVOICEPARTNER, fetchContractInvoicePartnerEdit),
    takeEvery(actions.SAVE_CONTRACTINVOICEPARTNER, fetchContractInvoicePartnerSave),
    takeEvery(actions.DELETE_CONTRACTINVOICEPARTNER, fetchContractInvoicePartnerDelete),
    takeEvery(actions.RE_FETCH_CONTRACTINVOICEPARTNERS, fetchContractInvoicePartnersRefresh),
  ])
}
